import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { productShortName } from '../data/offer';
export function PurchaseNotification() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const show = window.setTimeout(() => setVisible(true), 5000);
    const hide = window.setTimeout(() => setVisible(false), 15000);
    return () => {
      window.clearTimeout(show);
      window.clearTimeout(hide);
    };
  }, []);
  return <AnimatePresence data-id="element-211" data-mp="21ydbohrq2ixm">
      {visible && <motion.aside initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 14
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-4 right-4 z-50 w-[calc(100%-2rem)] max-w-sm rounded-lg border border-earth-200 border-l-4 border-l-gold-500 bg-white p-4 pr-10 text-earth-900 shadow-xl shadow-earth-900/20" aria-live="polite" data-id="element-212" data-mp="1wxxvlig22xby">
          <button type="button" onClick={() => setVisible(false)} className="absolute right-2 top-2 rounded p-1 text-earth-500 transition-colors duration-150 ease-out hover:text-forest-950 focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-300" aria-label="Cerrar aviso" data-id="element-213" data-mp="1sdth7h1vhgu1">
            <XIcon className="h-4 w-4" data-id="element-214" data-mp="19p50l7af9xo2" />
          </button>
          <div className="flex gap-3" data-id="element-215" data-mp="19nljjegxzil8">
            <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-forest-700" aria-hidden="true" data-id="element-216" data-mp="1egenw18i0ows" />
            <div data-id="element-217" data-mp="zs0ef7gku279">
              <p className="text-[10px] font-extrabold uppercase tracking-[.16em] text-earth-500" data-id="element-218" data-mp="zsjsue70q8gj">Acceso confirmado</p>
              <p className="mt-1 text-sm leading-snug" data-id="element-219" data-mp="14qlcp1c9qbt2">
                Al completar tu compra recibes el
                <br data-id="element-220" data-mp="qsnbkxmykbvi" />
                <span className="font-bold text-forest-950" data-id="element-221" data-mp="vpngv6bzhalk">{productShortName}</span>
              </p>
              <p className="mt-2 text-xs text-earth-700" data-id="element-222" data-mp="2xejb5e7tul1c">Acceso digital inmediato por correo electrónico</p>
            </div>
          </div>
        </motion.aside>}
    </AnimatePresence>;
}